import styled from 'styled-components';

import { CalciteButton } from 'components/Calcite';

import { FormControl } from 'components/StyledComponents';

export const FormatSettingsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledFormControl = styled(FormControl)`
  padding-top: 2rem;
`;

export const StyledDeriveButton = styled(CalciteButton)`
  margin-left: auto;
  height: fit-content;
  margin-top: 1.5rem;
`;
